import { z } from "zod";

// LanguageLine SIP interpreters a provider can manually dial into a call from
// the Tray. The list comes from the `languageline-translator-options` ConfigCat
// flag as a JSON string so addresses can differ per environment (e.g. the
// LanguageLine TEST lines outside prod). The automatic dial-out for patients
// with a preferred language still uses the `languageline-address` flag.
const translatorOptionSchema = z.object({
  label: z.string().min(1),
  sipUri: z.string().startsWith("sip:"),
  video: z.boolean(),
});

const translatorOptionsSchema = z.array(translatorOptionSchema).min(1);

export type TranslatorOption = z.infer<typeof translatorOptionSchema>;

// Identify the interpreter participant to everyone in the call. The CHAI
// patient app (superclinical-fe CallPanel) matches these values; keep in sync.
export const TRANSLATOR_USER_ID = "translator";
export const TRANSLATOR_DISPLAY_NAME = "Interpreter";
export const TRANSLATOR_AUDIO_ONLY_DISPLAY_NAME = "Interpreter (audio only)";

/**
 * Parses the `languageline-translator-options` flag value. Returns null when
 * the flag is unset, and throws when it is set but malformed.
 */
export const parseTranslatorOptions = (
  flagValue: unknown,
): TranslatorOption[] | null => {
  if (flagValue === undefined || flagValue === null || flagValue === "") {
    return null;
  }
  if (typeof flagValue !== "string") {
    throw new Error("languageline-translator-options must be a JSON string");
  }
  return translatorOptionsSchema.parse(JSON.parse(flagValue));
};
